export const MOBILE_FLOATING_BUTTON_TRANSITION =
  'origin-center transition-all duration-300 ease-out';

export const MOBILE_FLOATING_BUTTON_VISIBLE =
  'opacity-100 translate-x-0 scale-100';

export const MOBILE_FLOATING_BUTTON_OFFSCREEN_RIGHT =
  'pointer-events-none translate-x-[calc(100%+var(--floating-button-offscreen-gap,2rem))]';
